export default __webpack_public_path__ + "static/media/shoppingCartBlue.14c458fd.svg";